<template>
    <Header ueberschrift="Atemschutz"/>
    <img src="@/assets/Atemschutz.jpeg" alt="Atemschutz" class="atemschutz"/>
</template>

<script>
import Header from '@/components/Header.vue'

export default {
    name: 'Atemschutz',
    components: {
        Header
    },
    data() {
        return {

        }
    },
    methods: {

    },
    created() {
    },
    mounted() {
        
    }
}
</script>

<style lang="scss" scoped>
.atemschutz{
    width: 90%;
    margin-top: 5.5rem;
}
</style>